export var getFormFieldState = function getFormFieldState(_ref) {
  var disabled = _ref.disabled,
    error = _ref.error;
  if (disabled) return 'disabled';
  if (error) return 'error';
  return 'normal';
};